export const ACTIONS_COUNT_REQUEST = 'ACTIONS_COUNT_REQUEST'
export const ACTIONS_COUNT_SUCCESS = 'ACTIONS_COUNT_SUCCESS'
export const ACTIONS_COUNT_FAIL = 'ACTIONS_COUNT_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'